import React from 'react';
import './Bars.css';

const Navbar = () => {
	return (
		<nav className="navbar navbar-light ">
			<div className="caja">
				<div className="logo d-inline-block align-text-top" onClick={() => window.location.reload()}></div>
				<div className="navtitulo">
					<h4>Universidad Pedagógica Nacional Francisco Morazán</h4>
					<h6>Sistema de inscripción para el proceso de admisión</h6>
					<hr />
				</div>
			</div>
		</nav>
	);
};

export default Navbar;
